import { ossConsolePath } from '@logto/schemas';
import { conditionalArray, joinPath } from '@silverhand/essentials';
import { useMemo } from 'react';
import { useHref } from 'react-router-dom';

import { isCloud, isMultiTenant } from '@/consts/env';

/**
 * The hook that returns the absolute URL for the sign-in or sign-out callback.
 * The path is not related to react-router, which means the path will also include
 * the basename of react-router if it's set.
 *
 * In self-hosted multi-tenant OSS the react-router basename is `/console`, so `useHref`
 * already prepends it — we must skip the manual `ossConsolePath` concatenation in that mode
 * to avoid producing `/console/console/callback`.
 */
const useRedirectUri = (flow: 'signIn' | 'signOut' = 'signIn') => {
  const needsManualOssConsolePath = !isCloud && !isMultiTenant;
  const path = useHref(
    joinPath(
      ...conditionalArray(
        needsManualOssConsolePath && ossConsolePath,
        flow === 'signIn' ? '/callback' : '/'
      )
    )
  );
  const url = useMemo(() => new URL(path, window.location.origin), [path]);

  return url;
};

export default useRedirectUri;
